// 全局 token
export const APP_TOKEN = 'APP_TOKEN';

export const WEB_HTTP_AUTH_HEADER = 'WEB_HTTP_AUTH_HEADER';

export const CERTIFICATE_TABIND = 'CERTIFICATE_TABIND'

export const INDENITY_ID = 'INDENITY_ID'

export const SEARCH_IND = 'SEARCH_IND'

export const CHOSE_TABLE = 'CHOSE_TABLE'

export const EXCLE_LIST = 'EXCLE_LIST'

export const EXCLE_EVA_LIST = 'EXCLE_EVA_LIST'

export const APP_ORGID = 'APP_ORGID'

export const APP_ORGID_NAME = 'APP_ORGID_NAME'